/**
 * Builds B2B application body text from structured fields before contact form submit.
 */
(function initB2bApplyForm() {
  const form = document.querySelector('[data-b2b-apply-form]');
  if (!(form instanceof HTMLFormElement)) return;

  form.addEventListener('submit', (event) => {
    const bodyField = form.querySelector('[data-b2b-body-field]');
    const company = form.querySelector('[data-b2b-company]');
    const gstin = form.querySelector('[data-b2b-gstin]');
    const volume = form.querySelector('[data-b2b-volume]');
    const message = form.querySelector('[data-b2b-message]');

    if (!(bodyField instanceof HTMLTextAreaElement)) return;

    const lines = ['B2B & Bulk Order Application', ''];

    if (company instanceof HTMLInputElement && company.value.trim()) {
      lines.push(`Company: ${company.value.trim()}`);
    }
    if (gstin instanceof HTMLInputElement && gstin.value.trim()) {
      lines.push(`GSTIN: ${gstin.value.trim()}`);
    }
    if (volume instanceof HTMLInputElement && volume.value.trim()) {
      lines.push(`Expected monthly volume: ${volume.value.trim()}`);
    }
    lines.push('');
    if (message instanceof HTMLTextAreaElement && message.value.trim()) {
      lines.push(message.value.trim());
    } else {
      lines.push('Please approve my business account for bulk ordering.');
    }

    bodyField.value = lines.join('\n');
  });
})();
